import React from "react";
import { Box } from "@mui/material";
import { Bus, Car } from "lucide-react";

const Badge = ({ Icon, color, bgColor, size, position }) => (
  <Box
    sx={{
      position: "absolute",
      bottom: -2,
      [position]: -2,
      width: size,
      height: size,
      borderRadius: "50%",
      bgcolor: bgColor,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1.5px solid",
      borderColor: "background.paper",
    }}
  >
    <Icon size={size * 0.6} color={color} strokeWidth={2.5} />
  </Box>
);

export const OptionTypeIcon = ({ optionType, size = 40 }) => {
  const busSize = size * 0.6;
  const badgeSize = size * 0.32;

  const badges = (() => {
    switch (optionType) {
      case "onnibus-full":
        return (
          <>
            <Badge Icon={Car} color="#1565c0" bgColor="#e3f2fd" size={badgeSize} position="left" />
            <Badge Icon={Car} color="#1565c0" bgColor="#e3f2fd" size={badgeSize} position="right" />
          </>
        );
      case "onnibus-firstmile":
        return <Badge Icon={Car} color="#2e7d32" bgColor="#e8f5e9" size={badgeSize} position="left" />;
      case "onnibus-lastmile":
        return <Badge Icon={Car} color="#e65100" bgColor="#fff3e0" size={badgeSize} position="right" />;
      default:
        return null;
    }
  })();

  const isOnnibus = optionType?.startsWith("onnibus");

  return (
    <Box sx={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          bgcolor: isOnnibus ? "rgba(76, 175, 80, 0.1)" : "action.hover",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Bus size={busSize} color={isOnnibus ? "#2e7d32" : undefined} />
      </Box>
      {badges}
    </Box>
  );
};
